export default __webpack_public_path__ + "files/pattern_no_data-065b2417c278dd476281f70cd935c21d.png";